import { useEffect, useRef, useState } from 'react';
import { api, errMsg } from '../lib/api';
import i18n from '../lib/i18n';

export const usePasswordReset = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [challenge, setChallenge] = useState(null);
  const [grant, setGrant] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [seconds, setSeconds] = useState(0);
  const deadline = useRef(0);
  const sending = useRef(false);
  useEffect(() => {
    const timer = setInterval(() => setSeconds(Math.max(0, Math.ceil((deadline.current - performance.now()) / 1000))), 250);
    return () => clearInterval(timer);
  }, []);
  const step = grant ? 'password' : challenge ? 'code' : 'email';
  const act = async operation => {
    if (sending.current) return;
    sending.current = true; setBusy(true); setError('');
    try { await operation(); }
    catch (failure) { setError(!failure.response || failure.response.status >= 500 ? 'Password reset is temporarily unavailable. Please try again.' : errMsg(failure)); }
    finally { sending.current = false; setBusy(false); }
  };
  const send = () => act(async () => {
    const { data } = await api.post('/auth/password-reset/request', { email: email.trim(), locale: i18n.resolvedLanguage || 'en' });
    setChallenge(data); setGrant(null); setCode(''); setPassword(''); setRepeat('');
    deadline.current = performance.now() + data.resendAfter * 1000; setSeconds(data.resendAfter);
  });
  const submit = event => {
    event.preventDefault();
    if (step === 'email') return send();
    return act(async () => {
      if (step === 'code') {
        const { data } = await api.post('/auth/password-reset/verify', { challengeId: challenge.challengeId, code });
        setGrant(data); setCode(''); return;
      }
      if (password !== repeat) { setError('Passwords do not match'); return; }
      await api.post('/auth/password-reset/finish', { challengeId: grant.challengeId, resetToken: grant.resetToken, password, confirmPassword: repeat });
      setPassword(''); setRepeat(''); setGrant(null);
      const query = new URLSearchParams(window.location.search);
      window.location.replace('/login?passwordReset=1' + (query.get('customerApp') === '1' ? '&customerApp=1' : ''));
    });
  };
  return { email, setEmail, code, setCode, password, setPassword, repeat, setRepeat,
    challenge, busy, error, seconds, step, submit, send };
};